import { render, staticRenderFns } from "./FakturPajakByCompany.vue?vue&type=template&id=70440848&scoped=true"
import script from "./FakturPajakByCompany.vue?vue&type=script&lang=js"
export * from "./FakturPajakByCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70440848",
  null
  
)

export default component.exports